"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAspectRatio = void 0;
const aspectRatioFormatList = {
    "1.000": "1:1",
    "1.500": "3:2",
    "0.6667": "2:3",
    "1.333": "4:3",
    "0.7500": "3:4",
    "4.000": "4:1",
    "0.2500": "1:4",
    "1.600": "16:10",
    "0.6250": "10:16",
    "1.778": "16:9",
    "0.5625": "9:16"
};
/**
 * @param width The width of the area to find the aspect ratio off.
 * @param height The height of the area to find the aspect ratio off.
 * @returns A string representation of the aspect ratio, formatted like: 16:9 [1920 x 1080 px], if the entered vaules doesn't match any common formats, then it'll return "custom" instead of the format
 */
const GetAspectRatio = (width, height) => {
    const aspectRatio = ((width / height).toPrecision(4));
    let aspectRatioFormat = "";
    aspectRatioFormat = aspectRatioFormatList[aspectRatio];
    if (aspectRatioFormat === undefined) {
        aspectRatioFormat = "custom";
    }
    return aspectRatioFormat;
};
exports.GetAspectRatio = GetAspectRatio;
